import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { CoreModule } from './core/core.module';
import { MaterialModule } from './core/material/material.module';
import { SharedModule } from './shared/shared.module';
import { CreditorLoginComponent } from './pages/creditor-login/creditor-login.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ResolveGuard } from './core/guard/resolve.guard';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ReactiveFormsModule } from '@angular/forms';
//simport { UserProfileComponent } from './pages/creditor-home/user-profile/user-profile.component';
import { RegistraionPrintComponent } from './pages/registration-print/registration-print.component';
import { from } from 'rxjs';
import { ApplicationInsightsErrorHandler } from './shared/services/error-handler.service';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { TermsAndConditionsComponent } from './pages/terms-and-conditions/terms-and-conditions.component';
import { OAuthModule } from './shared/oAuth/angular-oauth-oidc.module';
import { InterceptorService } from './shared/services/http.interceptor';
import { PrivilegeGuard } from 'src/app/core/guard/privilege.guard';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

@NgModule({
  declarations: [
    AppComponent,
    CreditorLoginComponent,
    NotFoundComponent,
    RegistraionPrintComponent,
    TermsAndConditionsComponent,
    AboutUsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    CoreModule,
    SharedModule,
    MaterialModule,
    HttpClientModule,
    MatDialogModule,
    NgxSpinnerModule,
    MatBottomSheetModule,
    CKEditorModule,
    OAuthModule.forRoot()
  ],

  providers: [ResolveGuard, PrivilegeGuard, { provide: ErrorHandler, useClass: ApplicationInsightsErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true }],
  bootstrap: [AppComponent],
})
export class AppModule { }
